module.exports = __webpack_public_path__ + "img/service.658ab4f2.png";